import React from 'react';
import './RowPopup.css'; // Import CSS file for styling
  {/* <ul>
          {Object.entries(rowData).map(([key, value]) => (
            <li key={key}>
              <strong>{key}: </strong>{value}
            </li>
          ))}
        </ul> */}


const RowPopup = ({ rowData, onClose }) => {
  return (
    <div className="popup">
      <h2>Bill Details</h2>
         <button className="close-btn" onClick={onClose}>Close</button>
      <div className="popup-inner">
        
      
<table>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Sid</th>
          <th>Name</th>
          <th>Age</th>
          <th>Gender</th>
          <th>RegisteredOn</th>
          <th>IC</th>
          <th>Bill</th>
          
          {/* Add more columns as needed */}
        </tr>
      </thead>
      <tbody>
        {rowData.map((row, index) => (
          <tr key={index}>
             <td>{(index+1)}</td>
             <td>{row.SidCode}</td>
            <td>{row.CustomerName}</td>
            <td>{row.Age}</td>
            <td>{row.Gender}</td>
            <td>{row.RegisteredOn}</td>
            <td>{row.IC}</td>
            <td>{row.ActualTotal}</td>
            {/* Add more cells as needed */}
          </tr>
        ))}
      </tbody>
    </table>
     
      </div>
    </div>
  );
};

export default RowPopup;


